import { Icon, Tooltip, Typography } from 'shared/ui'
import styles from './styles.module.scss'

type IRinglessSelectInfoTooltipProps = {
  withDurationLimit?: boolean
}

export const RinglessSelectInfoTooltip = ({
  withDurationLimit = true,
}: IRinglessSelectInfoTooltipProps) => {
  return (
    <Tooltip
      label={
        <>
          <Typography variant={'body-sm-regular'} ariaLabel={'RinglessSelectTooltipLabel'}>
            Audio:
          </Typography>
          <Typography
            variant={'body-sm-regular'}
            className={styles.description}
            ariaLabel={'RinglessSelectTooltipDescription'}
          >
            {withDurationLimit ? ' up to 3 min (mp3,wav,wave)' : ' mp3, wav, wave'}
          </Typography>
        </>
      }
      placement={'top'}
      width={220}
    >
      <Icon icon={'question'} color={'var(--content-neutral-primary)'} />
    </Tooltip>
  )
}
